import React from 'react';
export function ContentSecurityPolicy({ nonce }) {
    const baseUri = "base-uri 'none'";
    const objectSrc = "object-src 'none'";
    let scriptSrc = `script-src 'nonce-${nonce}' 'strict-dynamic' 'unsafe-inline' https:`;
    scriptSrc += " 'unsafe-eval'";
    return (React.createElement("meta", { httpEquiv: "Content-Security-Policy", content: `${baseUri};${objectSrc};${scriptSrc}` }));
}
//# sourceMappingURL=ContentSecurityPolicy.js.map